module.exports = __webpack_public_path__ + "img/kayumanis.0f1c9c13.png";